<template>
  <div class="main">
    <div class="top" v-show="false">
      <span class="icon" @click="giHistory"><img class="goHistory" src="../../assets/image/08.png"
             alt=""></span>
      <span class="iconText">参考教案</span>
    </div>
    <div class="content">
      <div class="contentBox">
        <!-- <div class="select">
          <a-row>
            <a-col :span="12">
              <a-select :default-value="defaultName"
                        style="width:505px;"
                        @change="handleChange">
                <a-select-option v-for="(item, index) in bookName"
                                :key="index"
                                :value="item.id">
                  {{item.bookClassify}}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div> -->
        <div class="unit">
          <a-tabs @change=changeName size="large">
            <a-tab-pane :key="index" :tab="item.name" v-for="(item, index) in titleName">
              <ul>
                <li v-for="(item, index) in bookList" :key="index">
                  <div class="bgc">
                    <div class="bgcType">
                      <img v-if="item.fileList && item.fileList[0] && (item.fileList[0].path.split('.')[1]=='ppt'||item.fileList[0].path.split('.')[1]=='pptx')"
                           class="bgcTypeImg" src="../../assets/image/PPT.png" alt="">
                      <img v-if="item.fileList && item.fileList[0] && ( item.fileList[0].path.split('.')[1]=='doc'||item.fileList[0].path.split('.')[1]=='docx')"
                           class="bgcTypeImg" src="../../assets/image/34.png" alt="">
                      <img v-if="item.fileList && item.fileList[0] && (item.fileList[0].path.split('.')[1]=='pdf')"
                           class="bgcTypeImg" src="../../assets/image/33.png" alt="">
                    </div>
<!--                    <div class="bgcText">-->
                      <div class="titleName">{{item.fileList[0].name}}</div>
                      <!-- <div class="name">{{item.unit}}</div> -->
                      <img class="button" @click="goLook(item.fileList[0].path)" src="../../assets/image/resource_download.png">
<!--                      </div>-->
                  </div>
                </li>
              </ul>
              <div style="padding-top: 90px;" v-if="!bookList||bookList.length==0">
                <a-empty />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
export default {
  name: 'NewLessonResources',
  data() {
    return {
      defaultName: '高中语文必修上',
      bookName: [], //
      typeClassify: 1, // 单篇教案和单元教案
      bookClassify: 1,
      titleName: [
        { name: '单篇教案', key: '1' },
        { name: '单元教案', key: '2' },
      ],
      bookList: [],
      resBasePath: this.$resBasePath,
      wordShow: false,
      fileUrl: '',
      isBuy: false, // 判断是否购买 默认未购买
    };
  },
  mounted() {
    // this.getAllBookClassify()
    // this.changeName()
    this.getResourcesList();
    this.bookName = [];
    this.$store.state.myBookList.forEach((item) => {
      if (item.isBuy == 1) {
        this.bookName.push({
          bookClassify: item.name,
          id: item.id,
        });
      }
    });
    if (this.bookName.length > 0) {
      this.bookClassify = this.bookName[0].id;
      this.getResourcesList();
    }
  },
  methods: {
    handleChange(value) {
      this.bookClassify = value;
      this.getResourcesList();
    },
    changeTab(item) {},
    goLook(item) {
      // this.fileUrl = 'https://file.e-snails.com/spath' + item.filePath
      const a = document.createElement('a'); // 创建a标签
      a.setAttribute('download', ''); // download属性
      a.setAttribute('target', '_blank');
      a.setAttribute('href', this.$downLoad + item); // href链接
      a.click();
    },
    closeWord() {
      this.wordShow = false;
    },
    giHistory() {
      this.$router.go(-1);
    },
    getAllBookClassify() {
      // 获取书册分类
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getAllBookClassify',
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.bookName = res.resultData;
          this.defaultName = res.resultData[0].bookClassify;
        }
      });
    },
    getResourcesList() {
      const param = {
        typeClassify: this.typeClassify,
        styleId: localStorage.getItem('styleId'),
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getResourcesByStyleId',
        body: param,
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.bookList = res.resultData;
        }
      });
    },
    getList() {},
    changeName(key) {
      this.typeClassify = 1;
      if (!key) {
        this.typeClassify = Number(this.typeClassify);
      } else {
        this.typeClassify = Number(this.typeClassify) + key;
      }
      this.getResourcesList();
    },
  },
};
</script>

<style lang="less" scoped>
ul,
li,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}
.main {
  // background-color: #fff;
  .top {
    height: 50px;
    //background-color: #fff;
    padding-left: -10px;
    position: relative;
    .goHistory {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }
    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 30px;
    }
    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }
  .content {
    min-height: 550px;
    height: calc(100vh - 185px);
    background: #fff;
    //width: 1240px;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 12px;
    .contentBox {
     // width: 1040px;
      padding: 0px 30px;
      margin: 0 auto;
      .select {
        width: 100%;
        height: 50px;
      }
      .unit {
        ul {
          li {
            width: 100%;
            height: 80px;
            background: #f5f0e5;
            margin-top: 10px;
            border-radius: 8px;
            .bgc {
              padding-left: 30px;
              padding-top: 20px;
              display: flex;
              //justify-content: space-between;
              .bgcType {
               // width: 1%;
                //flex: 2;
                .bgcTypeImg {
                  width: 40px;
                  height: 40px;
                }
              }
              //.bgcText {
              //  flex: 22;
              //  height: 100%;
                .titleName {
                //  width: 40%;
                 // flex: 2;
                  font-size: 18px;
                  color: #474747;
                  height: 35px;
                  height: 35px;
                  margin-left: 20px;
                  margin-top: 10px;
                }
                .button {
                 // flex: 2;
                  cursor: pointer;
                  //margin: auto 20px;
                  margin-left: auto;
                  margin-right: 30px;
                  margin-top: 10px;
                  background-image: url('../../assets/image/resource_download.png');
                  width: 30px;
                  height: 30px;
                  line-height: 30px;
                  text-align: right;
                  color: #fff;
                  font-size: 16px;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                  a {
                    color: #fff;
                  }
                }
             // }
            }
          }
        }
      }
    }
  }
}
/deep/.ant-modal-close-x {
  width: 39px;
}
</style>
